(() => {
  const drawerMenu = document.querySelector('.js-drawer-menu');
  const drawerMenuToggleButton = document.querySelector('.js-drawer-menu-toggle');
  const openIcon = document.querySelector('.js-open-drawer');
  const closeIcon = document.querySelector('.js-close-drawer');
  const classes = {
    hide : 'is-hidden',
    drawerOpen: 'is-drawer-open'
  };

  if (!drawerMenu || !drawerMenuToggleButton || !openIcon || !closeIcon) {
    throw new Error('target element is missing');
  }

  let isOpen = false;

  const changeVisibilityOfElementsExceptDrawerToVisible = () => {
    const othersElements =  document.querySelectorAll('#PageContainer');
    for (const otherElement of othersElements) {
      otherElement.style.visibility = 'visible';
    }
  }

  const changeVisibilityOfElementsExceptDrawerToHidden = () => {
    const othersElements =  document.querySelectorAll('#PageContainer');
    for (const otherElement of othersElements) {
      otherElement.style.visibility = 'hidden';
    }
  }

  const openDrawerMenu = () => {
    drawerMenu.setAttribute('aria-hidden', 'false');
    drawerMenuToggleButton.setAttribute('aria-expanded', 'true');

    openIcon.classList.add(classes.hide);
    closeIcon.classList.remove(classes.hide);

    document.body.classList.add(classes.drawerOpen);

    changeVisibilityOfElementsExceptDrawerToHidden();

    isOpen = true;
  };

  const closeDrawerMenu = () => {
    drawerMenu.setAttribute('aria-hidden', 'true');
    drawerMenuToggleButton.setAttribute('aria-expanded', 'false');

    openIcon.classList.remove(classes.hide);
    closeIcon.classList.add(classes.hide);

    document.body.classList.remove(classes.drawerOpen);

    changeVisibilityOfElementsExceptDrawerToVisible();

    isOpen = false;
  };

  const onClickToggleButton = () => {
    if (isOpen) {
      closeDrawerMenu();
      return;
    }
    openDrawerMenu();
  };

  drawerMenuToggleButton.addEventListener('click', onClickToggleButton);
})();
